var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.40823 10.0851H19.121L13.8011 15.1371C13.533 15.3917 13.3824 15.737 13.3824 16.097C13.3824 16.4571 13.533 16.8024 13.8011 17.057C14.0691 17.3115 14.4326 17.4545 14.8116 17.4545C15.1906 17.4545 15.5541 17.3115 15.8221 17.057L23.5818 9.68689C24.1394 9.15644 24.1394 8.29722 23.5818 7.76677L15.8221 0.3976C15.5429 0.132433 15.1776 0 14.8114 0C14.4452 0 14.0794 0.132131 13.8008 0.397298C13.5327 0.651842 13.3821 0.997147 13.3821 1.35721C13.3821 1.71727 13.5327 2.06257 13.8008 2.31712L19.121 7.36977H1.40823C0.627113 7.38083 0 7.98542 0 8.72743C0 9.46944 0.627113 10.074 1.40823 10.0851Z",
    fill: "#3F3B3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.bad7b8b3ca91b39d0cc16ce01cc522ee.svg";
export { ForwardRef as ReactComponent };